"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isC2REnabledAccount = void 0;
const accounts_1 = require("companion-app-components/flux/accounts");
const accountsUtils_1 = require("companion-app-components/flux/accounts/accountsUtils");
const store_1 = __importDefault(require("store"));
const isC2REnabledAccount = (accountId) => {
    const account = accounts_1.accountsSelectors.getAccountById(store_1.default === null || store_1.default === void 0 ? void 0 : store_1.default.getState(), accountId);
    return account && !(0, accountsUtils_1.isAccountDisconnected)(account) && (account === null || account === void 0 ? void 0 : account.isC2REnabled);
};
exports.isC2REnabledAccount = isC2REnabledAccount;
